import { validateSchema } from 'src/feathers/hooks';
import yup from 'src/feathers/yup';

export default (app) => {
  const service = app.service('api/users');

  service.schema = yup.object({
    first_name: yup.trimmedString().label('First Name').required(),
    last_name: yup.trimmedString().label('Last Name').required(),
    email: yup.trimmedString().label('Email').email().required(),
    phone: yup.trimmedString().label('Phone')
  });

  service.hooks({
    before: {
      all: [],
      find: [],
      update: [validateSchema],
      patch: [validateSchema]
    },
    after: {
      all: [updateUserInSentry],
      find: [],
      update: [],
      patch: []
    },

    error: {
      all: [],
      find: [],
      update: [],
      patch: []
    }
  });
};

const updateUserInSentry = async (context) => {
  if (context.id === null) {
    const sentryClient = context.app.get('sentryClient');
    sentryClient.configureScope((scope) => {
      const user = context.result;
      scope.setUser({
        id: user._id,
        username: user.full_name,
        email: user.email
      });
    });
  }
};
